import {FontDefinition} from "data/models/shared/recommended-fonts";

export const defaultFonts: {
  brandFont: FontDefinition;
  headlineFont: FontDefinition;
  bodyFont: FontDefinition;
  quoteFont: FontDefinition;
  captionFont: FontDefinition;
} = {
  brandFont: {
    family: "Alice:400",
    name: "Alice",
    weight: 400,
    italic: undefined,
  },
  headlineFont: {
    family: "Roboto:700",
    name: "Roboto",
    weight: 700,
    italic: undefined,
  },
  bodyFont: {
    family: "Source Serif Pro:400",
    name: "Source Serif Pro",
    weight: 400,
    italic: undefined,
  },
  quoteFont: {
    family: "Alice:400",
    name: "Alice",
    weight: 400,
    italic: undefined,
  },
  captionFont: {
    family: "Roboto:700",
    name: "Roboto",
    weight: 700,
    italic: undefined,
  },
};
